<template>
	<div class="chat-container w-100 position-relative">
    <top-navbar :title="$t('general.give-a-feedback')" :run_function="true" @on-back="backPage" />
    <loader v-if="ticket_detail.loader" />
    <template v-else>
      <div class="container pt-10">
      	<div class="row slim-grid-row border-bottom mb-4">
      		<div class="col-10">
      			<div class="px-1 pb-3">
  	      		<p class="mb-0 font-semibold ls-0-15 text-20 text-truncate">{{$t('merchant.ticket-code')}} {{ticket_detail.data.ticket_code}}</p>
  	        	<p class="mb-0 body-2-2-1 text-12">{{ticket_detail.data.merchant.name}} {{$t('general.ticket')}}</p>
  	      	</div>
      		</div>
      	</div>
      	<div class="border-bottom pb-3 mb-4">
      		<p class="mb-0 body-2 text-18 mt-3 text-color-dark">{{$t('general.rates-your-experience')}}</p>
          <star-rating 
            class="my-2"
            :star-size="30"
            active-color="#fbc632" 
            @rating-selected="setRating" 
            :increment="1">    
          </star-rating>
      	</div>
      	<div class="border-bottom pb-3 mb-1">
      		<p class="mb-0 body-2 text-18 mt-3 text-color-dark pb-2">{{$t('general.add-photo')}}</p>
          <label v-if="form.preview_image.length < 5" for="file_image" class="border bg-light-page rounded d-inline-block align-middle mr-2 mb-0 cursor-pointer">
	      	  <img src="../../assets/img/icon/ar-camera-light.png" class="text-center m-3" width="35">
          </label>
          <div class="border rounded d-inline-block align-middle mr-2 position-relative" v-if="form.preview_image.length > 0" v-for="(img,index) in form.preview_image" style="height: 69px;width: 69px;">
            <img :src="img.img" width="69" height="69" class="img-fit">
            <div class="custom-close-img cursor-pointer" @click="cancelImage(index)">
              <img src="../../assets/img/icon/cancel.png" class="align-top" height="9" width="9">
            </div>
          </div>
          <input type="file" multiple @change="handleFileChange($event)" accept="image/png, image/jpeg, image/jpg" id="file_image" class="d-none" />
      	</div>
        <p class="mb-4 body-3-3-1 mt-2 text-10">{{$t('general.max-upload-5')}}</p>
      	<p class="mb-0 body-2 text-18 mt-3 mb-1 text-color-dark pb-2">{{$t('general.describe-your-experience')}}</p>
      	<textarea class="form-control px-2 body-1 mb-1 mt-3" v-model="form.message"></textarea>
  	  </div>
    	<div class="container pb-3 mt-5">
        <p v-if="error.show" class="mb-1 body-3-3-1 text-danger mt-2 text-10 text-center">{{error.data}}</p>
        <div class="rounded-6 px-4 py-14px text-center mb-4 cursor-pointer" @click="submitFeedback" :class="{'bg-green': is_data_valid, 'bg-green-disabled' : !is_data_valid}">
          <pulse-loader :loading="push_loading" v-if="push_loading"></pulse-loader>
          <p v-else class="text-white body-15 mb-0">{{$t('general.submit-feedback')}}</p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  
  import {get,upload} from '@/services/index.js';
  const { email } = require("vuelidate/lib/validators");
  import {mapGetters} from 'vuex';
  import {compressImage} from '@/utils/index.js';

  export default{
    data(){
      return{
        push_loading: false,
        form:{
         star: 0,
         image: [],
         preview_image:[],
         message: ''
        },
        ticket_detail:{
          data: {},
          loader: true
        },
        error:{
          show: false,
          data: ''
        }
      }
    },
    mounted(){
      this.loadTicketDetail()
    },
    computed:{
      is_data_valid(){
        let data = false
        if (this.form.star != 0 && this.form.message != '') {
          data = true
        }
        return data
      }
    },
    methods:{
      ...mapGetters(['getMerchant']),
      handleFileChange(evt){
        this.form.image = []
        this.form.preview_image = []
        for(let i = 0; i < evt.target.files.length; i++){
          if (i < 5) {
            let data = {
              img : URL.createObjectURL(evt.target.files[i])
            }
            this.form.preview_image.push(data)
            this.form.image.push(evt.target.files[i])
          }else{
            break;
          }
        }
      },
      cancelImage(index){
        this.form.image.splice(index, 1);
        this.form.preview_image.splice(index, 1);
      },
      setRating(star){
        this.form.star = star
      },
      loadTicketDetail(){
        this.ticket_detail.loader = true
        get("CORE","tx-ticket-detail/"+this.$route.params.ticket_id).then(response=>{
          let res = response.data;
          if (res.success) {
            this.ticket_detail.data = res.data
          }
          this.ticket_detail.loader = false
        })
      },
      async submitFeedback(){
        if (this.is_data_valid) {
          this.push_loading = true
          var fd = new FormData();
          if (this.form.image.length != 0) {
            for(let i=0;i < this.form.image.length;i++){
              let img_list = "image_"+(i+1)
              let img_data = await compressImage(this.form.image[i]).then(compressResult=>{
                if(compressResult != false){
                  return compressResult
                }else{
                  return null
                }
              })
              fd.append(img_list, img_data, img_data.name);
            }
          }
          fd.append("tc_tx_order",this.$route.params.ticket_id)
          fd.append("star",this.form.star)
          fd.append("message",this.form.message)

          upload("CORE", "send-ticket-feedback",fd)
            .then(stream => stream.json())
            .then(data => {
              if(data.success){
                this.backPage()
              }else{
                this.error.show = true
                this.error.data = data.message
              }
              this.push_loading = false
            })
            .catch(error => console.error(error))
        }
      },
      backPage(){
        this.$router.push({
          path: '/'+this.getMerchant().code+'/ticket/order-history/'+this.$route.params.ticket_id
        })
      }
    }
  }
</script>
<style scoped>
  input{
		border: none;
    border-radius: 0px !important;
    border-bottom: 1px solid #0000001A;
	}
	textarea{
		border: none;
		height: 100px;
    border-radius: 0px !important;
    border-bottom: 1px solid #0000001A;
	}
	textarea::placeholder {
  	color: #d6d6d6!important;
	}
	input::placeholder {
  	color: #d6d6d6!important;
	}
  .custom-close-img{
    position: absolute;
    top: -6px;
    right: -6px;
    height: 20px;
    width: 20px;
    padding: 4px;
    background-color: #3a3a3a;
    border-radius: 50%;
    border: 2px solid #fff;
  }
  .cursor-pointer{
    cursor: pointer;
  }
 </style>


// WEBPACK FOOTER //
// src/pages/ticket/FeedbackForm.vue